import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
// Remove video elements from DOM when prefers-reduced-motion is active (fixes iOS Low Power Mode)
(function() {
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  
  function removeVideos() {
    document.querySelectorAll('.hero__video, video-background-component video').forEach(function(video) {
      video.remove();
    });
  }
  
  function handleReducedMotion(e) {
    if (e.matches) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', removeVideos);
      } else {
        removeVideos();
      }
    }
  }
  
  handleReducedMotion(mq);
  mq.addEventListener('change', handleReducedMotion);
})();
